import React from 'react';
import './Movableplates.css';
import movablePlateImg from '../../../imgs/Movableplate.webp'; 

const Movableplates = () => {
  return (
    <div className="movableplates-container">
      <div className="movable-card image-card">
        <img src={movablePlateImg} alt="Movable Platen Clamping System" />
      </div>
      <div className="movable-card text-card">
        <h2>Movable Platen Clamping System</h2>
        <p>
          Our system uses four independent clamping cylinders in a modular design. This ensures an even force
          distribution, extending the life of the tie-bars and guaranteeing the best product quality.
          Thanks to our integrated design, maintenance is quick and efficient, leading to shorter downtimes.
        </p>
      </div>
    </div>
  );
};

export default Movableplates;
